import { ConvertDateToUtc } from "./DateUtils";
import { RouteMenu } from "model/other";
import moment from "moment";
import { RegUtil } from "./RegUtils";

export const isUndefinedOrNull = (variable: any) => {
  if (variable && variable !== null) {
    return false;
  }
  return true;
};

export const findCurrentRoute = (
  routes: Array<RouteMenu> = [],
  path: string = ""
) => {
  let current: Array<string> = [];
  let subMenu: Array<string> = [];
  routes.forEach((route) => {
    if (route.subMenu.length > 0) {
      route.subMenu.forEach((item) => {
        if (item.subMenu.length > 0 && item.showMenuThird) {
          item.subMenu.forEach((item1) => {
            if (path === item1.path) {
              current.push(item1.key);
              subMenu.push(route.key);
              subMenu.push(item.key);
            }
          });
        }
        if (path === item.path) {
          current.push(item.key);
          subMenu.push(route.key);
        }
      });
    }
    if (path === route.path) {
      current.push(route.key);
    }
  });
  let obj = {
    current: current,
    subMenu: subMenu,
  };
  return obj;
};

const checkPath = (p1: string, p2: string, pathIgnore?: Array<string>) => {
  if (p1.includes(":") || p2.includes(":")) {
    if (p1.includes(":")) {
      let urls1 = p1.split("/");
      let urls2 = p2.split("/");
      let index = urls1.findIndex((a) => a.includes(":"));
      if (pathIgnore && pathIgnore.includes(urls2[index])) {
        return false;
      }
      urls1[index] = urls2[index];
      return urls1.join("/") === urls2.join("/");
    }
  }
  if (p2.includes(":")) {
    let urls1 = p2.split("/");
    let urls2 = p1.split("/");
    let index = urls1.findIndex((a) => a.includes(":"));
    if (pathIgnore && pathIgnore.includes(urls2[index])) {
      return false;
    }
    urls1[index] = urls2[index];
    return urls1.join("/") === urls2.join("/");
  }
  return p1 === p2;
};

export const formatSuffixPoint = (point: number | string): string => {
  let format = point.toString();
  //return `${format.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")} điểm`;
  return `${format.replace(RegUtil.SUFIX_POINT, "$1,")}`;
};

export const getListBreadcumb = (
  routes: Array<RouteMenu> = [],
  path: string = ""
) => {
  let result: Array<RouteMenu> = [];
  if (path === "" || path === "/") {
    return result;
  }
  result.push(routes[0]);
  routes.forEach((route) => {
    if (checkPath(route.path, path)) {
      result.push(route);
    } else {
      if (route.subMenu.length > 0) {
        route.subMenu.forEach((route1) => {
          if (checkPath(route1.path, path, route1.pathIgnore)) {
            result.push(route);
            result.push(route1);
          } else {
            if (route1.subMenu.length > 0) {
              route1.subMenu.forEach((route2) => {
                if (checkPath(route2.path, path, route2.pathIgnore)) {
                  result.push(route);
                  result.push(route1);
                  result.push(route2);
                }
              });
            }
          }
        });
      }
    }
  });
  return result;
};

export const formatCurrency = (currency: number | string | boolean): string => {
  try {
    let format = currency.toString();
    return format.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  } catch (e) {
    return "";
  }
};

export const generateQuery = (obj: any) => {
  if (obj !== undefined) {
    let a: string = Object.keys(obj)
      .map((key, index) => {
        let url = "";
        if (
          obj[key] !== undefined &&
          obj[key] !== null &&
          obj[key] !== "" &&
          obj[key].length !== 0
        ) {
          let value = obj[key];
          if (obj[key] instanceof Array) {
            value = obj[key].join(",");
          }
          if (obj[key] instanceof Date) {
            value = ConvertDateToUtc(obj[key]);
          }
          if (moment.isMoment(obj[key])) {
            value = obj[key].utc().format();
          }
          url = key + "=" + encodeURIComponent(value) + "&";
        }
        return url;
      })
      .join("");
    if (a.charAt(a.length - 1) === "&") {
      a = a.substring(0, a.length - 1);
    }
    return a;
  }
  return "";
};

export const replaceFormat = (currency: number | string): number => {
  let format = currency.toString();
  return parseInt(format.replace(/,/gi, ""));
};

export const replaceFormatString = (currency: number | string): string => {
  let format = currency.toString();
  return format.replace(/,/gi, "");
};

export const ListUtil = {
  notEmpty: (a: Array<any> | undefined) => {
    return a !== undefined && a.length >= 0;
  },
};